import type { ProductFlag } from './productFlipperFlagRelation';

export const AD_LINK_MANAGER = 'ad_link_manager';
export const AD_LINK_TEMPLATES = 'ad_link_templates';
export const BULK_AD_LINKS = 'bulk_ad_links';
export const BULK_QUICK_LINKS = 'bulk_quick_links';
export const QUICK_LINK_MANAGER = 'quick_link_manager';
export const QUICK_LINK_TEMPLATES = 'quick_link_templates';
export const SEO_APP_ATTRIBUTION = 'seo_app_attribution';
export const QUICK_LINK_ANALYTICS = 'quick_link_analytics';
export const LINK_CREATE_EDIT_TRACK = 'link_create_edit_track';
export const PPP_DESKTOP_JOURNEY = 'desktop_journeys';
export const SSO_BASIC = 'sso_basic';
export const PROTECTED_API = 'protected_api';
export const CUSTOM_QR_CODES_UI = 'custom_qr_codes_ui';
export const CUSTOM_QR_CODES = 'custom_qr_codes';
export const ADS_ATTRIBUTION_TIER_1 = 'ads_attribution_tier_1';
export const ADS_ATTRIBUTION_TIER_2 = 'ads_attribution_tier_2';
export const ADS_ATTRIBUTION_TIER_3 = 'ads_attribution_tier_3';

export enum ProductSuite {
  ESSENTIALS = 'ESSENTIALS',
  ESSENTIALS_WITH_UNIVERSAL_ADS = 'ESSENTIALS_WITH_UNIVERSAL_ADS',
  LINKHUB = 'LINKHUB',
  LINKHUB_WITH_UNIVERSAL_ADS = 'LINKHUB_WITH_UNIVERSAL_ADS',
}

/**
 * Set of all PPP features
 */
export const PRODUCT_FLAGS = new Set<ProductFlag>([
  AD_LINK_MANAGER,
  AD_LINK_TEMPLATES,
  BULK_AD_LINKS,
  BULK_QUICK_LINKS,
  QUICK_LINK_MANAGER,
  QUICK_LINK_TEMPLATES,
  SEO_APP_ATTRIBUTION,
  SSO_BASIC,
  PROTECTED_API,
  CUSTOM_QR_CODES_UI,
  ADS_ATTRIBUTION_TIER_1,
  ADS_ATTRIBUTION_TIER_2,
  ADS_ATTRIBUTION_TIER_3,
]);

export const PRODUCT_SUITE_FLAGS: Record<ProductSuite, ProductFlag[]> = {
  [ProductSuite.ESSENTIALS]: [QUICK_LINK_MANAGER],
  [ProductSuite.ESSENTIALS_WITH_UNIVERSAL_ADS]: [QUICK_LINK_MANAGER, AD_LINK_MANAGER],
  [ProductSuite.LINKHUB]: [QUICK_LINK_MANAGER, QUICK_LINK_TEMPLATES, BULK_QUICK_LINKS],
  [ProductSuite.LINKHUB_WITH_UNIVERSAL_ADS]: [
    QUICK_LINK_MANAGER,
    QUICK_LINK_TEMPLATES,
    BULK_QUICK_LINKS,
    AD_LINK_MANAGER,
    AD_LINK_TEMPLATES,
    BULK_AD_LINKS,
  ],
};
